import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './styles/App.css';
import './styles/model.css';

class ModelDetail extends Component {
  render() {
    const model = this.props.model;
    const framework = this.props.framework;

    return model ? (
      <div className="col-md-4 d-flex align-items-stretch">
        <Link to={`/model/${model.slug}`} className="model-detail-div box-shadow w-100">
          <h2 className="title">{model.title}</h2>
          { model.stars ? <span className="model-stars"><i class="fas fa-star"></i> {model.stars}</span> : "" }<hr/>
          <p className="description" dangerouslySetInnerHTML={{__html: model.description}}></p>
          { framework ? <span className="btn btn-primary nohover">{framework.title}</span> : ""
          }
          
          <div className="categories-div">
          { 
            model.categories.map((category) =>
              <span key={model.slug + "-category-" + category.slug} className="btn btn-category btn-category-detail nohover">{category.short_title}</span>
            )
          }
          </div>
        </Link>
      </div>
    ) : "";
  }
}

export default ModelDetail;


// WEBPACK FOOTER //
// ./src/ModelDetail.jsx